
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-compare/[firstid]/[secondid]",
      function () {
        return require("private-next-pages/parlor-compare/[firstid]/[secondid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-compare/[firstid]/[secondid]"])
      });
    }
  